/**
 * 视频通话来电通知 - 函数式调用
 * ⚠️：组件mount时所有props都是undefined，执行open时才会传入真正的prop值
 */
import { createComponentInstance } from '@/utils/mount-component'
import { inBrowser } from '@/utils'
import VideoTopPop from './VideoTopPop.vue'
import { getAsset } from '@/utils'

let instance

const DEFAULT_OPTIONS = {
  autoClose: 30, // 默认30秒后自动关闭
  targetMember: {
    avatar: getAsset('@/assets/images/common/avatar.webp'),
    nickname: '',
  },
}

let currentOptions = Object.assign({}, DEFAULT_OPTIONS)

function initInstance() {
  instance = createComponentInstance(VideoTopPop)
}

/**
 * 显示视频通话来电通知
 * @param {Object} options - 配置选项
 * @param {Number} options.autoClose - 自动关闭时间（毫秒），0表示不自动关闭
 * @param {Object} options.targetMember - 目标用户信息对象
 * @param {String|Number} options.targetMember.id - 目标用户 ID
 * @param {String|Number} options.targetMember.member_id - 目标用户 member_id
 * @param {String} options.targetMember.avatar - 用户头像URL
 * @param {String} options.targetMember.nickname - 用户昵称
 * @param {String} options.targetMember.nation_flag - 用户国家国旗
 * @param {String} options.targetMember.nation - 用户国家名称
 * @param {Number} options.comeFrom - 来源标识
 * @param {String} options.popId - 弹窗ID
 * @param {Function} options.onAnswer - 接听回调
 * @param {Function} options.onTimeout - 超时回调
 * @param {Function} options.onClose - 关闭回调
 */
export function showVideoTopPop(options = {}) {
  if (!inBrowser) {
    return
  }

  if (!instance) {
    initInstance()
  }

  const mergedOptions = Object.assign({}, currentOptions, options)
  const originalOnAnswer = mergedOptions.onAnswer
  const originalOnTimeout = mergedOptions.onTimeout
  const originalOnClose = mergedOptions.onClose

  instance.open(
    Object.assign({}, mergedOptions, {
      onAnswer: () => {
        originalOnAnswer?.()
      },
      onTimeout: () => {
        originalOnTimeout?.()
      },
      onClose: () => {
        originalOnClose?.()
      },
      onClosed: () => {
        if (instance?.unmount) {
          instance.unmount()
          instance = null
        }
      },
    })
  )
}

/**
 * 关闭当前显示的视频通话来电通知
 */
export function closeVideoTopPop() {
  if (instance) {
    instance.toggle(false)
  }
}

/**
 * 检查 VideoTopPop 是否正在显示
 * @returns {boolean}
 */
export function isVideoTopPopShow() {
  return !!(instance && instance.isShow?.())
}
